var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Mark Lost Shipment")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Lost By")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listtype),
      expression: "listtype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "listtype",
      "id": "listtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("--All--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ServiceCenter"
    }
  }, [_vm._v("ServiceCenter")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Linehaul"
    }
  }, [_vm._v("Linehaul")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientList,
      "selected-option": _vm.clientItemObj,
      "name": "clientid",
      "placeholder": "Select client"
    },
    on: {
      "select": _vm.getclientsObj
    },
    model: {
      value: (_vm.clientid),
      callback: function($$v) {
        _vm.clientid = $$v
      },
      expression: "clientid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzone),
      expression: "hubzone"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "hubzone",
      "id": "hubzone"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.zone_obj.hubzoneid
    }
  }, [_vm._v(_vm._s(_vm.zone_obj.hubzonename))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "hubname",
      "id": "hubname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.defaultHhub.hubID
    }
  }, [_vm._v(_vm._s(_vm.defaultHhub.HubName))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "col-sm-5",
    class: {
      'form-control': true
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "amount",
      "id": "amount"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": "0"
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NetPaymnet"
    }
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OctroiMRP"
    }
  }, [_vm._v("Octroi MRP")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountcomparator),
      expression: "amountcomparator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.amount != 0 ? 'required' : ''))),
      expression: "`${amount != 0 ? 'required' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('amountcomparator')
    },
    staticStyle: {
      "margin-right": "6px",
      "z-index": "1"
    },
    attrs: {
      "name": "amountcomparator",
      "id": "amountcomparator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amountcomparator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ">"
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("=")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-sm-12",
    class: {
      'form-control': true,
      'error': _vm.errors.has('netpaymnet')
    },
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "type": "text",
      "name": "netpaymnet",
      "formatter": _vm.format_number
    },
    model: {
      value: (_vm.netpaymnet),
      callback: function($$v) {
        _vm.netpaymnet = $$v
      },
      expression: "netpaymnet"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amountcomparator')),
      expression: "errors.has('amountcomparator')"
    }],
    staticClass: "text-danger"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netpaymnet')),
      expression: "errors.has('netpaymnet')"
    }],
    staticClass: "text-danger"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Aging")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gapdays),
      expression: "gapdays"
    }],
    staticClass: "col-sm-6",
    class: {
      'form-control': true,
      'error': _vm.errors.has('gapdays')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "gapdays",
      "id": "gapdays"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gapdays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": "0"
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ShipmentGapDays"
    }
  }, [_vm._v("Aging From Manifestation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NotifyGapDays"
    }
  }, [_vm._v("Aging From Lost Notify")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gapdayscomparator),
      expression: "gapdayscomparator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.gapdays != 0 ? 'required' : ''))),
      expression: "`${gapdays != 0 ? 'required' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('gapdayscomparator')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "gapdayscomparator",
      "id": "gapdayscomparator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gapdayscomparator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ">"
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("=")])]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.gapdays != 0 ? 'required|numeric' : ''))),
      expression: "`${gapdays != 0 ? 'required|numeric' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtgapdays')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "type": "text",
      "name": "txtgapdays"
    },
    model: {
      value: (_vm.txtgapdays),
      callback: function($$v) {
        _vm.txtgapdays = $$v
      },
      expression: "txtgapdays"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB Numbers")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumbers),
      expression: "awbnumbers"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumbers')
    },
    attrs: {
      "rows": "2",
      "name": "awbnumbers",
      "id": "awbnumbers"
    },
    domProps: {
      "value": (_vm.awbnumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" (Note: Use comma (,) for multiple AWB numbers) ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate') || _vm.dateError
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.validateDateFields,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dateError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dateError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate') || _vm.dateError
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": _vm.validateDateFields,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dateError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dateError))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Source")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source),
      expression: "source"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "source",
      "id": "source"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("--All--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Auto Lost Notified by System"
    }
  }, [_vm._v("Auto Lost Notified by System")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Potential Risk Tagged"
    }
  }, [_vm._v("Potential Lost")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost Notified Manually"
    }
  }, [_vm._v("Lost Notified Manually")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "top": "2em"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "disabled": _vm.hubname == 0
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("    \n                "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.exportForm
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")]), _vm._v("    \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearchLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSearchLoading = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gapdayscomparator')),
      expression: "errors.has('gapdayscomparator')"
    }],
    staticClass: "text-danger"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('txtgapdays')),
      expression: "errors.has('txtgapdays')"
    }],
    staticClass: "text-danger"
  })], 1)])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowing),
      expression: "isShowing"
    }]
  }, [_c('legend', [_vm._v("Lost Debit Shipments List")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Lost Reasons")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ddlLostReasons),
      expression: "ddlLostReasons"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ddlLostReasons')
    },
    attrs: {
      "name": "ddlLostReasons",
      "id": "ddlLostReasons"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ddlLostReasons = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getSubLostReasonData($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Reason--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost_By_SR"
    }
  }, [_vm._v("Lost By SR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost_By_Staff"
    }
  }, [_vm._v("Lost By Staff")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost_By_Delivery_Agent"
    }
  }, [_vm._v("Lost By Delivery Agent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dispute_Client_Consignee"
    }
  }, [_vm._v("Dispute – Client/Consignee")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost_by_coloader"
    }
  }, [_vm._v("Lost by coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost_by_local_transport"
    }
  }, [_vm._v("Lost by local transport")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddlLostReasons')),
      expression: "errors.has('form-1.ddlLostReasons')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select reason.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Sub Lost Reasons")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ddlSubLostReason),
      expression: "ddlSubLostReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "ddlSubLostReason",
      "id": "ddlSubLostReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ddlSubLostReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Sub Reason--")]), _vm._v(" "), _vm._l((_vm.subLostReasonsList), function(sublostReasons_obj) {
    return _c('option', {
      domProps: {
        "value": sublostReasons_obj.Reason
      }
    }, [_vm._v(_vm._s(sublostReasons_obj.Reason))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddlSubLostReason')),
      expression: "errors.has('form-1.ddlSubLostReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select sub reason.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('b-form-fieldset', [_c('div', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("Raise Debit & Mark Lost")])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecords) + " "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.totalSelectedRecords) + " ")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [(_vm.isLostNewFeaturesisOnThisHub) ? _c('input', {
    key: _vm.form.shippingidchk.length,
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isAllSelected
    },
    on: {
      "change": function($event) {
        return _vm.selectItems($event)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkbox),
      expression: "checkbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkbox) ? _vm._i(_vm.checkbox, null) > -1 : (_vm.checkbox)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": [function($event) {
        var $$a = _vm.checkbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkbox = $$c
        }
      }, _vm.calculateselectedcount]
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentList), function(shipmentdata) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.shippingidchk),
        expression: "form.shippingidchk"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": shipmentdata,
        "checked": Array.isArray(_vm.form.shippingidchk) ? _vm._i(_vm.form.shippingidchk, shipmentdata) > -1 : (_vm.form.shippingidchk)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.form.shippingidchk,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shipmentdata,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "shippingidchk", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "shippingidchk", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "shippingidchk", $$c)
          }
        }, function($event) {
          return _vm.calculateselectedcount($event, shipmentdata)
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("flteramount")(shipmentdata.NetPayment)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("flteramount")(shipmentdata.OctroiMRP)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.NotifyStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CurrentHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.OriginHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.FinalDestinationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.NotifyGapDays) + " " + _vm._s(shipmentdata.NotifyGapDays > 1 ? '(days)' : '(day)'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShipmentGapDays) + " " + _vm._s(shipmentdata.ShipmentGapDays > 1 ? '(days)' : '(day)'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CreatedBy))])])
  }), 0)])])], 1), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title1"
  }, [_vm._v("Approval Debit Status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "b-table table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [(_vm.apiResponseforTable.length > 0) ? _vm._l((_vm.apiResponseforTable), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      style: (row.ReturnCode == 100 ? _vm.styleObjectSuccess : _vm.styleObjectFailure)
    }, [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', {
      style: (row.ReturnCode == 100 ? _vm.styleObjectSuccess : _vm.styleObjectFailure)
    }, [_vm._v(_vm._s(row.ReturnMessage))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.partialDebit) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.partialRaiseDebit()
      }
    }
  }, [_vm._v("Continue for Raise debit")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.RSCPopUP),
      callback: function($$v) {
        _vm.RSCPopUP = $$v
      },
      expression: "RSCPopUP"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title1"
  }, [_vm._v("Shipments contains RSC shipments and Non RSC shipments")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeRSCValidationModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "b-table table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("RSC Shipping ID")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.RSCShippingArr), function(Shipments, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Shipments.Shipment))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "b-table table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("NON RSC Shipping ID")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.NonRSCShippingArr), function(Shipments, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Shipments.Shipment))])])
  })], 2)])])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "text-align": "center"
    }
  }, [_vm._v("Please select only NonRSC or RSC shipments at a time")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeRSCValidationModel()
      }
    }
  }, [_vm._v("Close")])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Net Payment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Octroi MRP")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notify Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Aging From Lost Notify")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Aging From Manifestation")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4515c7b0","hasScoped":true}!./src/views/components/LOST/MarkLostShipment/MarkLostShipment.component.html
// module id = 1080
// module chunks = 1